import { clearError, setError } from './actions';
const initialState = null;
function errorReducer(state = initialState, { type, payload }) {
    switch (type) {
        case setError.toString():
            return payload;
        case clearError.toString():
            return initialState;
        default:
            return state;
    }
}
export default errorReducer;
